import { PERSONA_NODE_ID_PROPERTY } from '../services/fetchFavoritePersonaSearchFolder';
export function getValueFromExtendedProperty(propertyName, folder) {
    var properties = folder.ExtendedProperty &&
        folder.ExtendedProperty.filter(function (property) {
            return property.ExtendedFieldURI && property.ExtendedFieldURI.PropertyName === propertyName;
        });
    if (properties && properties.length > 0) {
        return properties[0].Value;
    }
    return undefined;
}
export function getPersonaNodeIdFromExtendedProperty(folder) {
    return getValueFromExtendedProperty(PERSONA_NODE_ID_PROPERTY, folder);
}
//# sourceMappingURL=getValueFromExtendedProperty.js.map